// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import {
  IDynamicBindableValue,
  IDynamicBindableValueCombination,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { SearchProduct } from '@epicuro-next/models/products';
import {
  BoughtThisSeasonProviderArgs,
  BoughtThisSeasonProviderConfigArgs,
  RecommendedItemProducts,
  RecommendedItemsResponseType,
} from 'models-recommendation';

import { ResolveValueErrorType } from '../../../types/resolve-value-error';

type MetaData = {
  hash: string;
  providerId: string;
  correlationId: string;
  servingConfig: string;
};

export function getDataForBoughtThisSeason(
  panelNameProvider: IDynamicBindableValue,
  brandIdProvider: IDynamicBindableValue,
  boughtThisSeasonProvidersArgsProvider: IDynamicBindableValue,
  groupByPropertyProvider: IDynamicBindableValue,
): IDynamicBindableValueCombination {
  return {
    values: [
      {
        provider: 'HttpBodyProvider',
        property: {
          values: [
            panelNameProvider,
            brandIdProvider,
            boughtThisSeasonProvidersArgsProvider,
          ],
          transform: transformArgumentsToHttpRequestFetchString.toString(),
        },
      },
      groupByPropertyProvider,
    ],
    transform: transformHttpBodyToProductsData.toString(),
  };
}

function transformArgumentsToHttpRequestFetchString(args: unknown): string {
  const [panelName, brandId, boughtThisSeasonProvidersArgs] = args as [
    string,
    string,
    BoughtThisSeasonProviderConfigArgs,
  ];

  const properties: BoughtThisSeasonProviderArgs = {
    brandId,
    productsAmount: boughtThisSeasonProvidersArgs.productsAmount,
    fromDate: boughtThisSeasonProvidersArgs.fromDate,
    toDate: boughtThisSeasonProvidersArgs.toDate,
    filterMissingImages:
      boughtThisSeasonProvidersArgs.filterMissingImages ?? undefined,
    loadPrices: boughtThisSeasonProvidersArgs.loadPrices ?? undefined,
    isDelivered: (
      boughtThisSeasonProvidersArgs.isDelivered as unknown as string
    )?.length
      ? (boughtThisSeasonProvidersArgs.isDelivered as boolean)
      : undefined,
    isGlobalNoos: (
      boughtThisSeasonProvidersArgs.isGlobalNoos as unknown as string
    )?.length
      ? (boughtThisSeasonProvidersArgs.isGlobalNoos as boolean)
      : undefined,
    searchSortType: boughtThisSeasonProvidersArgs.searchSortType ?? undefined,
    type: boughtThisSeasonProvidersArgs.type ?? undefined,
    orderType: boughtThisSeasonProvidersArgs.orderType ?? undefined,
    collapse: boughtThisSeasonProvidersArgs.collapse ?? undefined,
    productLevel: boughtThisSeasonProvidersArgs.productLevel ?? undefined,
    dateRangeField: boughtThisSeasonProvidersArgs.dateRangeField ?? undefined,
    aggregationType: boughtThisSeasonProvidersArgs.aggregationType ?? undefined,
    category: boughtThisSeasonProvidersArgs.category ?? undefined,
    sortDirection:
      window.neoclesDynamicFramework.recommendationsPanels.methods.isNonNullish(
        boughtThisSeasonProvidersArgs.sortDirection,
      )
        ? boughtThisSeasonProvidersArgs.sortDirection
        : undefined,
  };

  const body = {
    panelType: panelName,
    properties,
  };

  const fetchString =
    window.neoclesDynamicFramework.recommendationsPanels.methods.createHttpRequestFetchString(
      '/api/v2/recommendation/suggest',
      'POST',
      body,
    );

  return fetchString;
}

function transformHttpBodyToProductsData([httpBody, groupByPropertyName]: [
  RecommendedItemsResponseType<RecommendedItemProducts> | ResolveValueErrorType,
  string | null | undefined,
]): unknown {
  const doShuffle = false;
  const productsData =
    window.neoclesDynamicFramework.recommendationsPanels.methods.httpBodyToProductData(
      httpBody,
      doShuffle,
    ) as {
      products: ({ product: SearchProduct } & MetaData)[];
    } & MetaData;

  const doGroup =
    groupByPropertyName !== undefined &&
    groupByPropertyName !== null &&
    Boolean(groupByPropertyName.trim());

  if (doGroup) {
    const propertyNameToGroupOn = groupByPropertyName.trim();
    const productInfos = productsData.products;

    const productInfosToRemove: ({ product: SearchProduct } & MetaData)[] = [];
    const uniquePropertyValues = new Set<string>();
    // tslint:disable-next-line: no-any
    const getNestedProperty = (obj: Record<any, any>, path: string) => {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };
    for (const productInfo of productInfos) {
      const propertyValue = getNestedProperty(
        productInfo.product,
        propertyNameToGroupOn,
      );

      if (uniquePropertyValues.has(propertyValue)) {
        productInfosToRemove.push(productInfo);
      } else {
        uniquePropertyValues.add(propertyValue);
      }
    }

    for (const productInfo of productInfosToRemove) {
      const index = productsData.products.indexOf(productInfo);
      productsData.products.splice(index, 1);
    }
  }

  for (const productInfo of productsData.products) {
    productInfo.correlationId = productsData.correlationId;
    productInfo.hash = productsData.hash;
    productInfo.providerId = productsData.providerId;
    productInfo.servingConfig = productsData.servingConfig;
  }

  return productsData;
}
